import React, { useState, useRef } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import OSSTooltip from "../OSSTooltip/OSSTooltip";

const styles = () => ({
  wrapper: {
    // use 'grid' here to force a 'block-container-box' to trigger ellipsis
    display: "grid",
    width: "100%"
  },
  lineClamp: {
    display: "-webkit-box",
    "-webkit-line-clamp": "none",
    "-webkit-box-orient": "vertical",
    overflow: "hidden"
  }
});

const OSSTextOverflowTooltip = ({
  children,
  classes,
  lineClamp = null,
  tooltipText = typeof children === "string" ? children : "",
  typographyProps
}) => {
  const [tooltipEnabled, setTooltipEnabled] = useState(false);
  const domRef = useRef();
  const useLineClamp = Boolean(lineClamp);
  const lineClampStyles = useLineClamp
    ? {
        WebkitLineClamp: lineClamp.toString()
      }
    : {};

  if (domRef.current) {
    const element = domRef.current;

    if (
      element.offsetWidth < element.scrollWidth ||
      element.offsetHeight < element.scrollHeight
    ) {
      setTooltipEnabled(true);
    }
  }

  return (
    <span ref={domRef} className={classes.wrapper}>
      <OSSTooltip title={tooltipEnabled ? tooltipText : ""}>
        <Typography
          noWrap={!useLineClamp}
          variant="inherit"
          className={useLineClamp ? classes.lineClamp : ""}
          style={lineClampStyles}
          {...typographyProps}
        >
          {children}
        </Typography>
      </OSSTooltip>
    </span>
  );
};

export default withStyles(styles)(OSSTextOverflowTooltip);
